/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSalesInvoicePositionDto
 */
export interface CreateUpdateSalesInvoicePositionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    vat: CreateUpdateSalesInvoicePositionDtoVatEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    order: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    quantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    salesInvoiceId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoicePositionDto
     */
    parentId?: string | null;
}


/**
 * @export
 */
export const CreateUpdateSalesInvoicePositionDtoVatEnum = {
    _23: '23%',
    _8: '8%',
    _5: '5%',
    _0_KR: '0% KR',
    zw: 'zw.'
} as const;
export type CreateUpdateSalesInvoicePositionDtoVatEnum = typeof CreateUpdateSalesInvoicePositionDtoVatEnum[keyof typeof CreateUpdateSalesInvoicePositionDtoVatEnum];


/**
 * Check if a given object implements the CreateUpdateSalesInvoicePositionDto interface.
 */
export function instanceOfCreateUpdateSalesInvoicePositionDto(value: object): value is CreateUpdateSalesInvoicePositionDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('vat' in value) || value['vat'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('salesInvoiceId' in value) || value['salesInvoiceId'] === undefined) return false;
    return true;
}

export function CreateUpdateSalesInvoicePositionDtoFromJSON(json: any): CreateUpdateSalesInvoicePositionDto {
    return CreateUpdateSalesInvoicePositionDtoFromJSONTyped(json, false);
}

export function CreateUpdateSalesInvoicePositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSalesInvoicePositionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'amount': json['amount'],
        'vat': json['vat'],
        'order': json['order'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'active': json['active'],
        'salesInvoiceId': json['salesInvoiceId'],
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
    };
}

export function CreateUpdateSalesInvoicePositionDtoToJSON(value?: CreateUpdateSalesInvoicePositionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'amount': value['amount'],
        'vat': value['vat'],
        'order': value['order'],
        'quantity': value['quantity'],
        'active': value['active'],
        'salesInvoiceId': value['salesInvoiceId'],
        'isLocked': value['isLocked'],
        'parentId': value['parentId'],
    };
}

